export default "__VITE_ASSET__GvSvZLL1__"